<!--
 * @Author: Junjie
 * @Date: 2022-08-29 00:01:41
 * @LastEditTime: 2022-09-01 16:52:39
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/general/3d.vue
-->
<template>
  <iframe-f-report-view :src="iframeSrc"></iframe-f-report-view>
</template>

<script>

  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';

  export default {
    name: '3D',
    components: {
      IframeFReportView
    },
    data () {
      return {
        host: 'http://iwt.aiplus.cloud:888/#/',
        type: '',
        id: '',
        iframeSrc: ''
      }
    },
    created () {
      this.type = this.$route.params.type;
      this.id = this.$route.params.id;
      this.show();
    },
    methods: {
      show () {
        this.$nextTick(() => {
          let url = `${this.host}`;
          if (this.type && this.id) {
            url += `?${this.type}=${this.id}`;
          }
          this.iframeSrc = url;
        });
      },
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>